'use strict';
//import $ from 'jquery';
//window.$ = window.jQuery = $;

var _ = require('lodash');
window.$ = window.jQuery = require('jquery');
// Variations that I tried - one at a time
require ('materialize-css');
require ('slick-carousel');
//require('jquery-lazy');
require('tilt.js');
const login = require('./login');
const buy = require('./buy');
const account = require('./account');
const selectAddress = require('./selectAddress');
const order = require('./order');
const serviceSolic = require('./serviceSolic');
const deleteList = require('./deleteList');
const pagination = require('./pagination');
require('./course');
const send = require('./send');

$(function($) {
    let lazyImages = [...document.querySelectorAll('.lazy')];
    let instagramFt=true;
    function lazyLoad() {
        lazyImages.forEach(image => {
            if(elementVisible(image)){
                image.src = image.dataset.src;
                image.onload = () => image.classList.add('loaded');
            }
        });
        if(elementVisible($('.sectionInstagram')[0])){
            if(instagramFt){
                instagramFt=false;
                var access_token = location.hash.split('=')[1];
                var URL_API_INSTAGRAM = "https://api.instagram.com/v1/users/" + id_instagram + "/media/recent/?count=15&access_token=" + token_instagram + "&callback=?";
                $.getJSON(URL_API_INSTAGRAM, function (data) {
                    var i = 1;
                    $('.instragramImages').html("");
                    $.each(data.data, function (item, value) {
                        if (i <= 8) {
                            $('.instragramImages').append('' +
                                '<div class="col s6 m4 l3 col-instagram">' +
                                '<a target="_blank" href="' + data.data[item].link + '">' +
                                '   <div class="containerInstagram">' +
                                '       <div class="img">' +
                                '           <img src="' + value.images.low_resolution.url + '" alt="">' +
                                '       </div>' +
                                '   </div>' +
                                '</a>' +
                                '</div>');
                        }
                        i++;
                    });
                });
            }
        }
    }
    window.addEventListener('scroll', _.throttle(lazyLoad, 16));
    window.addEventListener('resize', _.throttle(lazyLoad, 16));
    lazyLoad();
    /*
    $("img.lazy").Lazy({
        chainable: false,
        threshold: 500,
        visibleOnly: false,
    });
     */
    $('.sectionFoodProductsHome .productsList .element').tilt({
        glare: false,
        maxGlare: 0.5,
        scale: 1.05,
        perspective: 2000
    });
});

import swal from 'sweetalert';
//importarScript("js/jquery.waypoints.min.js");
var contLogin,campo,emailRegex,elementsForm = new Array();

function importarScript(nombre) {
    var s = document.createElement("script");
    s.src = https + nombre;
    document.querySelector("head").appendChild(s);
}

$(document).ready(function(){
    $('.sectionHeader .woman').css('visibility','hidden');
    function cargar(){
        setTimeout(function () {
            $('#loading').css('display','none');
            $('#content').css('visibility','initial');
            $('body').css('overflow-x','visible');
            $('body').css('overflow-y','visible');
            if(localStorage.getItem('id_pack') != ''){
                $('#modalPackages'+localStorage.getItem('id_pack')).modal('open');
                localStorage.removeItem('id_pack');
            }
        },0);
    }
    window.load = cargar();
    $('.modal').modal();
    $('.sidenav').sidenav();
    $('.dropdown-trigger').dropdown({
        hover: true
    });
    $('.tabs').tabs();
    $('select').formSelect();

    $('#sliderBannerHome').slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        cssEase: 'linear',
        fade: true,
    });

    $('#sliderPackages').slick({
        dots: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('#slider-testimonios').slick({
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 4000,
        prevArrow: $('.prev-slider-testimonios'),
        nextArrow: $('.next-slider-testimonios'),
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.datepicker').datepicker({
        selectMonths: true, // Creates a dropdown to control month
        yearRange: 80, // Creates a dropdown of 15 years to control year,
        format: 'yyyy/mm/dd',
        i18n: {
            clear: 'Limpiar',
            cancel: 'Cancelar',
            done: 'Guardar',
            labelMonthNext: 'Próximo Mes',
            labelMonthPrev: 'Mes Anterior',
            months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            weekdaysFull: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
            weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
            weekdaysLetter: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        },
        closeOnSelect: true // Close upon selecting a date,
    });

    $('.sectionDescriptionProduct #sliderElement').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '#sliderElements'
    });
    $('.sectionDescriptionProduct #sliderElements').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '#sliderElement',
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    vertical: false,
                    verticalSwiping: false,
                }
            }
        ]
    });
});

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});
$(function() {
    $('.close-menu').click(function () {
        $('.sidenav').sidenav('close');
    });
});

$(window).scroll(function() {
    if ($(window).width() > 901) {
        if ($(document).scrollTop() > 96) {
            $('.header').css('height', '87px', '!important');
            $('.header').css('line-height', '87px', '!important');
            $('.header .brand-logo img').css('margin-top', '8%', '!important');
            $('.header .carPrincipal span').css('height', '27%', '!important');
            $('.header .select').css('margin-top', '30%', '!important');
        } else {
            if ($(document).scrollTop() >= 0 && $(document).scrollTop() <= 85) {
                $('.header').css('height', '120px', '!important');
                $('.header').css('line-height', '120px', '!important');
                $('.header .carPrincipal span').css('height', '20%', '!important');
                $('.header .brand-logo img').css('margin-top', '15%', '!important');
                $('.header .select').css('margin-top', '45%', '!important');
            }
        }
    }
});
$(function() {
    $('.sectionTallleresHome .taller').click(function () {
        $('.tallerActive').removeClass('tallerActive');
        $('.taller' + this.id).addClass('tallerActive');
        selectInfoTaller(this.id);
    });


    $('.sectionTallleresTaller .taller').click(function () {
        if ($(window).width() <= 600) {
            $('html, body').animate({
                scrollTop: $('.sectionTallleresTaller .big').offset().top - 100
            }, 2000);
        }
        $('.tallerActive').removeClass('tallerActive');
        $('.taller' + this.id).addClass('tallerActive');
        selectInfoTallerNew(this.id);
    });

    $('.sectionServiciosHome .openModalServicios').click(function () {
        $('#modalServicio' + this.id).modal('open');
    });

    $('.btnFormRegister').click(function () {
        grecaptcha.ready(function() {
            grecaptcha.execute('6LfRdtwZAAAAAGAsZTr769WArVkDxPg3hV2MFeU7', {action: 'submit'}).then(function(token) {
                $('#registerForm').prepend('<input type="hidden" name="token" value="' + token + '">');
                $('#registerForm').submit();
            });
        });
        //$('#registerForm').submit();
    });

    $('#registerForm').on('submit', function (e) {
        e.preventDefault();

        elementsForm = [
            //"nameBaby",
            //"birthDayBaby",
            //"ageBaby",
            //"feedingBaby",
            //"allergicHistoryBaby",
            //"diseasesBaby",
            //"physicalConditionBaby",
            "nameMother",
            //"ccMother",
            //"professionMother",
            "email",
            "password",
            "cellphone",
            "country",
            "state",
            "city",
            //'town',
            "address"
        ];

        contLogin = validationForm(elementsForm, contLogin = 1);

        if (contLogin == 0) {
            swal({
                text: "Debes completar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        var str = $.trim($("#password").val());
        var n = str.length;

        if (n <= 5) {
            $('#password').addClass('error');
            swal({
                text: "La contraseña debe tener minimo 6 caracteres",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        } else {
            $('#password').removeClass('error');
        }

        //var regex = /[\w-\.]{2,}@([\w-]{2,}\.)*([\w-]{2,}\.)[\w-]{2,4}/;
        let campo  = $("#email").val();
        let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        if (emailRegex.test(campo.trim())) {

            var data = $(this).serialize();

            swal({
                text: "Espere un momento",
                icon: imageURL,
                button: false,
            });

            $.ajax({
                url: https + "register",
                method: "POST",
                data: data,
                success: function (data) {
                    if ($.trim(data) == "1") {
                        $("#registerForm")[0].reset();
                        swal.close();
                        $('#modalRegisterExito').modal('open');
                        $('#modalRegister').modal('close');
                    } else if ($.trim(data) == "2") {
                        swal({
                            text: "Correo Electrónico ya registrado",
                            icon: imageURL,
                            button: "OK!",
                        });
                    } else {
                        swal({
                            text: "Error, hubo problemas",
                            icon: imageURL,
                            button: "OK!",
                        });
                    }
                }
            });

        } else {
            swal({
                text: "Debe digitar un correo electrónico valido",
                icon: imageURL,
                button: "OK",
            });
            document.getElementById("email").focus();
        }

    });

    $('.btnOpenLogin').click(function () {
        $('#modalLogin').modal('open');
        $('#modalRegister').modal('close');
        $('#modalRegisterExito').modal('close');
    });

    $('.sectionDescriptionProduct .colorSelect').click(function () {
        $('.sectionDescriptionProduct .activeColor').removeClass('activeColor');
        $('.colorSelect' + this.id).addClass('activeColor');
        $('.sectionDescriptionProduct #colorId').val(this.id);
        $('.sectionDescriptionProduct #sliderElement img').attr('src', https + $(this).attr('image'));
    });

    function validationForm(elementsForm, contLogin) {
        for (var i = 0; i < elementsForm.length; i++) {

            $('#' + elementsForm[i]).removeClass('error');

            if ($.trim($("#" + elementsForm[i]).val()) == "") {
                contLogin = 0;
                $('#' + elementsForm[i]).addClass('error');
            }

        }

        return contLogin;
    }

    $("#country").change(function () {
        var country_id = $(this).val();
        getStates(country_id, 'state');
    });

    $("#state").change(function () {
        var state_id = $(this).val();
        getCities(state_id, 'city');
    });

    $("#countryPackage").change(function () {
        var country_id = $(this).val();
        getStates(country_id, 'statePackage');
    });

    $("#statePackage").change(function () {
        var state_id = $(this).val();
        getCities(state_id, 'cityPackage');
    });

    function getStates(country_id, idElement) {
        $.ajax({
            url: https + "getStates",
            type: "POST",
            dataType: "json",
            data: {id: country_id, action: 'getStates'},
            success: function (datos) {
                $('#' + idElement + ' .opctions' + idElement).remove();
                $.each(datos, function (index, d) {
                    $('#' + idElement).append('<option class="opctions' + idElement + '" value="' + d.DisCodigo + '">' + d.DisNombre + '</option> ');
                });
            }
        });
    }

    function getCities(state_id, idElement) {
        $.ajax({
            url: https + "getCities",
            type: "POST",
            dataType: "json",
            data: {id: state_id, action: 'getCities'},
            success: function (datos) {
                $('#' + idElement + ' .opctions' + idElement).remove();
                $.each(datos, function (index, c) {
                    $('#' + idElement).append('<option class="opctions' + idElement + '" value="' + c.CiuCodigo + '">' + c.CiuNombre + '</option> ');
                });
            }
        });
    }

    function selectInfoTaller(idTaller) {
        $.ajax({
            url: https + "selectInfoTaller",
            type: "POST",
            dataType: "json",
            data: {id: idTaller, action: 'selectInfoTaller'},
            success: function (datos) {
                $(".sectionTallleresHome .tallerImgSmall").attr("src", https + datos.imgSmall);
                $('.sectionTallleresHome .tallerName').html(datos.name);
                $('.sectionTallleresHome .tallerDescription').html(datos.description);
                $("#modalTaller .tallerImgBig").attr("src", https + datos.imgBig);
                $('#modalTaller .tallerName').html(datos.name);
                var dateTaller = datos.date;
                let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
                let date = new Date(dateTaller.replace(/-+/g, '/'));
                var fechaNum = String(date.getDate());
                if (fechaNum.length == 1) {
                    fechaNum = '0' + fechaNum;
                }
                var mes_name = date.getMonth();
                if(id_price_session == 1){
                    var priceTaller = datos.price;
                    priceTaller = parseInt(priceTaller.replace(".", ""));
                    priceTaller = new Intl.NumberFormat().format(priceTaller);
                    priceTaller = priceTaller.replace(/,/g, ".") + ' COP';
                }else{
                    var priceTaller = datos.usd + ' USD';
                }
                $('#modalTaller .tallerDate').html(fechaNum + ' de ' + meses[mes_name]);
                $('#modalTaller .tallerCupos').html('Cupos: ' + datos.cupos);
                $('#modalTaller .tallerModality').html('Modalidad: ' + datos.modality);
                $('#modalTaller .tallerPrice').html('Precio: $' + priceTaller);
                $('#modalTaller .tallerDescription').html(datos.description);
                $("#modalTaller .btn").attr("id", datos.id);
            }
        });
    }

    function selectInfoTallerNew(idTaller)
    {

        $.ajax({
            url: https + "selectInfoTaller",
            type: "POST",
            dataType: "json",
            data: {id: idTaller, action: 'selectInfoTaller'},
            success: function (datos) {
                $(".sectionTallleresTaller .buton a").attr("href", https + 'taller/'+datos.slug);
                $(".sectionTallleresTaller .big").css("background-image", "url('"+https + datos.imgSmall+"')");
                $('.sectionTallleresTaller .tallerName').html(datos.name);
                var descriptionTallerNew = datos.description;
                $('.sectionTallleresTaller .tallerDescription').html(descriptionTallerNew.substr(0,450));
                $("#modalTaller .tallerImgBig").attr("src", https + datos.imgBig);
                $('#modalTaller .tallerName').html(datos.name);
                var dateTaller = datos.date;
                let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
                let date = new Date(dateTaller.replace(/-+/g, '/'));
                var fechaNum = String(date.getDate());
                if (fechaNum.length == 1) {
                    fechaNum = '0' + fechaNum;
                }
                var mes_name = date.getMonth();
                if(id_price_session == 1){
                    var priceTaller = datos.price;
                    priceTaller = parseInt(priceTaller.replace(".", ""));
                    priceTaller = new Intl.NumberFormat().format(priceTaller);
                    priceTaller = priceTaller.replace(/,/g, ".") + ' COP';
                }else{
                    var priceTaller = datos.usd + ' USD';
                }
                $('#modalTaller .tallerDate').html(fechaNum + ' de ' + meses[mes_name]);
                $('#modalTaller .tallerCupos').html('Cupos: ' + datos.cupos);
                $('#modalTaller .tallerModality').html('Modalidad: ' + datos.modality);
                $('#modalTaller .tallerPrice').html('Precio: $' + priceTaller);
                $('#modalTaller .tallerDescription').html(datos.description);
                $("#modalTaller .btn").attr("id", datos.id);
            }
        });
    }

    $('.buyTaller').click(function () {

        if($('#typeTaller').val() == '2'){
            if($('#nameTaller').val() == '' || $('#emailTaller').val() == '' || $('#phoneTaller').val() == ''){
                swal({
                    text: "Debes completar los campos de nombre,correo electronico y celular",
                    icon: imageURL,
                    button: "OK!",
                });
                return false;
            }
        }

        if(!$("#terms").is(':checked')){
            swal({
                text: "Debes aceptar los terminos y condiciones",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        let campo  = $("#emailTaller").val();
        emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        if (emailRegex.test(campo.trim())) {
        } else {
            swal({
                text: "Debe digitar un correo electrónico valido",
                icon: imageURL,
                button: "OK",
            });
            document.getElementById("emailTaller").focus();
            return false;
        }
        
        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
        });
        $.ajax({
            url: https + "buyTaller",
            method: "POST",
            data: {
                id: this.id,
                type: $('#typeTaller').val(),
                name: $('#nameTaller').val(),
                mail: $('#emailTaller').val(),
                phone: $('#phoneTaller').val(),
                action: "buyTaller"},
            success: function (data) {
                if ($.trim(data) == "complet") {
                    location.href = https + "payuTaller";
                } else {
                    swal({
                        text: "Ha ocurrido un error" + data,
                        icon: imageURL,
                        button: "OK!",
                    });
                }
            }
        });
    });

    $('.buyService').click(function () {
        if($('#typeService'+this.id).val() == '2'){
            if($('#nameService'+this.id).val() == '' || $('#emailService'+this.id).val() == '' || $('#phoneService'+this.id).val() == ''){
                swal({
                    text: "Debes completar los campos de nombre,correo electronico y celular",
                    icon: imageURL,
                    button: "OK!",
                });
                return false;
            }
        }

        let campo  = $("#emailService"+this.id).val();
        emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        if (emailRegex.test(campo.trim())) {
        } else {
            swal({
                text: "Debe digitar un correo electrónico valido",
                icon: imageURL,
                button: "OK",
            });
            document.getElementById("emailService"+this.id).focus();
            return false;
        }

        if(!$("#terms"+this.id).is(':checked')){
            swal({
                text: "Debes aceptar los terminos y condiciones",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }
        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });
        $.ajax({
            url: https + "buyService",
            method: "POST",
            data: {
                id: this.id,
                type: $('#typeService'+this.id).val(),
                name: $('#nameService'+this.id).val(),
                mail: $('#emailService'+this.id).val(),
                phone: $('#phoneService'+this.id).val(),
                action: "buyService"},
            success: function (data) {
                if ($.trim(data) == "complet") {
                    location.href = https + "payuService";
                } else {
                    swal({
                        text: "Ha ocurrido un error" + data,
                        icon: imageURL,
                        button: "OK!",
                    });
                }
            }
        });
    });

    $("#finderBlog").keypress(function (e) {
        if (e.which == 13) {
            var word = $('#finderBlog').val();
            word = getCleanedString(word);
            searchBlogs(word);
        }
    });

    function searchBlogs(word) {
        if (word == "") {
            swal({
                text: "Debe digitar algo a buscar",
                icon: imageURL,
                button: "OK!",
            });
        } else {
            location.href = https + 'buscar-blog/' + word;
        }
    }

    function getCleanedString(cadena) {
        // Definimos los caracteres que queremos eliminar
        var specialChars = "!@#$^&%*()+=-[]\/{}|:<>?,.";

        // Los eliminamos todos
        for (var i = 0; i < specialChars.length; i++) {
            cadena = cadena.replace(new RegExp("\\" + specialChars[i], 'gi'), '');
        }

        // Lo queremos devolver limpio en minusculas
        cadena = cadena.toLowerCase();

        // Quitamos espacios y los sustituimos por _ porque nos gusta mas asi
        cadena = cadena.replace(/ /g, "-");

        // Quitamos acentos y "ñ". Fijate en que va sin comillas el primer parametro
        cadena = cadena.replace(/á/gi, "a");
        cadena = cadena.replace(/é/gi, "e");
        cadena = cadena.replace(/í/gi, "i");
        cadena = cadena.replace(/ó/gi, "o");
        cadena = cadena.replace(/ú/gi, "u");
        cadena = cadena.replace(/ñ/gi, "n");
        return cadena;
    }
});


$(window).scroll(function() {
    if($(window).width() < 991) {
        if ($(document).scrollTop() > 80) {
            $('#youtubeFloat').css('display','block');
        }else{
            if($(document).scrollTop() >=0 && $(document).scrollTop() <=75){
                $('#youtubeFloat').css('display','none');
            }
        }
    }
});
$(function() {
    $('.registerMe').click(function () {
        $('#modalLogin').modal('close');
        $('#modalRegister').modal('open');
    });
    $('.header #changePrice').change(function () {
        location.href = https + 'change-price/'+$('.header #changePrice').val();
    });
    $('.sectionPackagesHome .sliderPackages .element').click(function () {
        $('#modalPackages'+this.id).modal('open');
    });
});

function elementVisible(element){
    var visible = true;
    var windowTop = $(document).scrollTop();
    var windowBottom = windowTop + window.innerHeight;
    var elementPositionTop =  $(element).offset().top;
    var elementPositionBottom = elementPositionTop + $(element).height();
    if (elementPositionTop >= windowBottom || elementPositionBottom <= windowTop) {
        visible = false;
    }
    return visible;
}
